export default __webpack_public_path__ + "src/images/packages/lachataigne-farm/abd73a65796abb55e1daf55907658e05-3.jpg";